import {
  Box,
  Button,
  Flex,
  Text,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
} from "@chakra-ui/react";
import React from "react";

type StatusConfirmationModalPropType = {
  heading: string;
  id?: string;
  isOpen: boolean;
  handleApiCall: () => void;
  onClose: () => void;
};

const StatusConfirmationModal = ({
  heading,
  id,
  isOpen,
  onClose,
  handleApiCall,
}: StatusConfirmationModalPropType) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={true}
      isCentered={true}
      size="md"
      returnFocusOnClose={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton
          borderRadius={"50%"}
          bg="#F0F4F9"
          top={"3em"}
          right={"3em"}
          transform={"translate(-100%)"}
          w="2.5em"
          h="2.5em"
        />
        <ModalBody borderRadius={"4px"}>
          <Box m="6em 2.5em 2.5em 2.5em">
            <Box mb="2.5em">
              <Text
                fontSize={"1.5em"}
                fontWeight={500}
                lineHeight={1.3}
                fontFamily="Inter"
              >
                {heading}
              </Text>
            </Box>

            <Flex gap={"1em"}>
              <Button
                w="100%"
                h="3em"
                color={"#00E267"}
                bg="white"
                border={"1px solid #00E267"}
                borderRadius={"4px"}
                _hover={{ bg: "#00E267", color: "white" }}
                onClick={() => {
                  handleApiCall();
                  onClose();
                }}
              >
                Yes
              </Button>
              <Button
                w="100%"
                h="3em"
                color={"#E93C31"}
                bg="white"
                borderRadius={"4px"}
                border="1px solid #E93C31"
                _hover={{ bg: "#E93C31", color: "white" }}
                onClick={() => {
                  onClose();
                }}
              >
                No
              </Button>
            </Flex>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default StatusConfirmationModal;
